import { type BulkImportStore } from '../store/bulk-import.store.types'

import { checkTypeCardActivity } from '@/utils/checkTypeCard'
import { type CardActivityType } from '@/models/card-activity/card-activity.model'

export function checkValidNextStepBulkImport({
  step,
  cardType,
  draftCards,
  settings,
}: {
  step: number
  cardType: BulkImportStore['cardType']
  draftCards: BulkImportStore['cardsDraft']
  settings: BulkImportStore['settings']
}) {
  if (step === 1) {
    return cardType !== 'idle'
  }

  if (step === 2) {
    const draftCardsEmpty = draftCards.size === 0
    const settingsGrading = settings.grading

    const arrayDraftCards = Array.from(draftCards.values())
    const hasContent = arrayDraftCards.some(card => card.prompt.length > 0)

    if (!hasContent || draftCardsEmpty) {
      return false
    }

    const { isRespond } = checkTypeCardActivity(cardType as CardActivityType)

    if (isRespond) {
      const method = settingsGrading.method

      if (method === 'rubric') {
        if (!settingsGrading.rubricId || settingsGrading.rubricId === '') {
          return false
        }
      } else if (method === 'simple') {
        const { gradingCriteriaWithAI, studentLevel, performanceExpectations } = settingsGrading
        const hasStudentLevel = studentLevel && studentLevel.length > 0
        const hasPerfExpectations = performanceExpectations && performanceExpectations.length > 0

        if (!((gradingCriteriaWithAI && hasStudentLevel) || (!gradingCriteriaWithAI && hasPerfExpectations))) {
          return false
        }
      } else if (method === 'manual') {
        // Manual is considered valid if selected
      } else if (method === 'standards_based') {
        if (!settingsGrading.standardId || !settingsGrading.target_proficiency_level) {
          return false
        }
      } else {
        // If method is not one of the above (e.g. undefined, or some other invalid string for respond cards)
        return false
      }
    }
    // If not a Respond card, or if it is Respond and passed its specific validation,
    // it will fall through to the main 'return true' if no other step conditions are met.
  }

  if (step === 3) {
    return cardType !== 'idle'
  }

  return true
}
